<div class="information-popover-container">
    <div class="regle-row" *ngFor="let regle of regles">
        <lua-icone [iconName]="regle.valid ? 'check_circle' : 'cancel'" [color]="regle.valid ? 'Vert' : 'Rouge'"></lua-icone>
        <p class="description">{{regle.description}}</p>
    </div>
</div>